import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Entrances from './components/Entrances';
import HotList from './components/HotList';
import Feed from './components/Feed';
import Feature from './components/Feature';
import Help from './components/Help';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <Entrances />
        <HotList />
        <Feed />
        <Feature />
        <Help />
      </main>
      <Footer />
    </div>
  );
}